import { Component, EventEmitter, Output } from '@angular/core'
import { closeJobSelectionDialog } from '../../../../shared/utils/job-selection-dialog-utils'
import {
    ClusteringNormalization,
    PipelineType,
    UmapDistanceMetric,
    UmapParameters,
} from '../../../../shared/model/jobs'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
    selector: 'app-umap-clustering-selection',
    templateUrl: './umap-selection.component.html',
    styleUrls: ['./umap-selection.component.scss'],
})
export class UmapSelectionComponent {
    ClusteringNormalizationValues = Object.values(ClusteringNormalization)
    UmapDistanceMetricValues = Object.values(UmapDistanceMetric)

    readonly umapForm: FormGroup

    readonly NUMBER_OF_NEIGHBORS_FORM_KEY = 'numberOfNeighbors'
    readonly NUMBER_OF_EPOCHS_FORM_KEY = 'numberOfEpochs'
    readonly MINIMUM_DISTANCE_FORM_KEY = 'minimumDistance'
    readonly SPREAD_FORM_KEY = 'spread'
    readonly RANDOM_INITIALIZATION_FORM_KEY = 'randomInitialization'
    readonly DISTANCE_METRIC_FORM_KEY = 'distanceMetric'
    readonly NORMALIZATION_FORM_KEY = 'normalization'

    constructor(private readonly formBuilder: FormBuilder) {
        this.umapForm = this.formBuilder.group({
            [this.NUMBER_OF_NEIGHBORS_FORM_KEY]: new FormControl(15, [
                Validators.required,
                Validators.min(1),
            ]),
            [this.NUMBER_OF_EPOCHS_FORM_KEY]: new FormControl(200.0, [
                Validators.required,
                Validators.min(1),
            ]),
            [this.MINIMUM_DISTANCE_FORM_KEY]: new FormControl(0.1, [
                Validators.required,
                Validators.min(0),
            ]),
            [this.SPREAD_FORM_KEY]: new FormControl(1.1, [Validators.required, Validators.min(0)]),
            [this.RANDOM_INITIALIZATION_FORM_KEY]: new FormControl(true, [Validators.required]),
            [this.DISTANCE_METRIC_FORM_KEY]: new FormControl(UmapDistanceMetric.Euclidean, [
                Validators.required,
            ]),
            [this.NORMALIZATION_FORM_KEY]: new FormControl(ClusteringNormalization.None, [
                Validators.required,
            ]),
        })
    }

    @Output() paramsSet = new EventEmitter<UmapParameters>()

    get paramsValid(): boolean {
        return this.umapForm.valid
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    confirmParams(): void {
        if (!this.paramsValid) return

        this.paramsSet.emit({ type: PipelineType.umapClustering, ...this.umapForm.value })
    }
}
